import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import { BodyRegularMedium } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const ProductAdderArea = styled.div`
  background-color: white;
  width: 100%;
  pointer-events: all;
  overflow: hidden;

  ${device.smallTablet} {
    border-radius: 8px;
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-area: 'products' 'selection-area';
  grid-template-columns: 1fr;
  padding: 8px;

  @media (min-width: 375px) {
    padding: 16px;
  }

  @media (min-width: 900px) {
    grid-template-columns: 260px 1fr;
  }

  ${device.smallTablet} {
    padding: 24px;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 1rem;
`;
